import TrackingService from '@/services/tracking';
import { theme } from '@/styles';
import React from 'react';
import styled from 'styled-components';

const CONTENT = [
  {
    id: 1,
    title: '수집 및 이용 목적',
    children: [
      `상담 및 견적서비스 이행
      (상담신청, 해피콜, 상담 매장 및 영업사원 배정,
        견적 서비스 제공)`,
    ],
  },
  {
    id: 2,
    title: '수집 항목',
    children: ['이름, 주소,휴대폰번호'],
  },
  {
    id: 3,
    title: '보유 및 이용 기간',
    children: [<p key=")">회원탈퇴 시</p>],
  },
];

const CONTENT_EVENT = [
  {
    id: 1,
    title: '수집 및 이용 목적',
    children: [
      `상담 및 견적서비스 이행
      (상담신청, 해피콜, 상담 매장 및 영업사원 배정,
      견적 서비스 제 공), 제품 설치`,
      `이벤트 참여자 문의 안내, 당첨자 개별 연락 및 안내,
      사은품 배송, 본인 확인`,
    ],
  },
  {
    id: 2,
    title: '수집 항목',
    children: ['이름, 주소,휴대폰번호'],
  },
  {
    id: 3,
    title: '보유 및 이용 기간',
    children: [<p key=")">회원탈퇴 시</p>],
  },
];

const VisitPersonalInfoCollection = ({
  isMember,
  isEvent,
}: {
  isMember: boolean;
  isEvent: boolean;
}) => {
  return (
    <Container {...TrackingService.tagGTM('visit_consult_agree_content')}>
      <TextDefault>
        {`매장 상담 예약 서비스 제공을 위해 고객님의 개인정보를 수집 및 이용하고자 합니다.
아래의 개인정보 수집 및 이용 동의를 거부할 권리가 있으나 동의를 거부하실 경우 매장 상담 예약이 불가합니다.`}
      </TextDefault>
      {isEvent ? (
        <Content>
          <Tr>
            {CONTENT_EVENT.map((item) => (
              <TableHeader key={item.id}>
                <TableData type={'head'}>{item.title}</TableData>
              </TableHeader>
            ))}
          </Tr>

          <Tr>
            {CONTENT_EVENT.map((item) => {
              return (
                <TableBody key={item.id} rowSpan={2}>
                  {item.children.map((val, idx) => (
                    <TableData
                      type="body"
                      key={idx}
                      height={item.children.length !== 2 ? '200px' : '100px'}
                    >
                      {item.id === 3 ? isMember ? val : <p>1년</p> : val}
                    </TableData>
                  ))}
                </TableBody>
              );
            })}
          </Tr>
        </Content>
      ) : (
        <Content>
          <Tr>
            {CONTENT.map((item) => (
              <TableHeader key={item.id}>
                <TableData type={'head'}>{item.title}</TableData>
              </TableHeader>
            ))}
          </Tr>
          <Tr>
            {CONTENT.map((item) => (
              <TableBody key={item.id}>
                <TableData type="body">
                  {item.id === 3 ? (
                    isMember ? (
                      item.children
                    ) : (
                      <p>1년</p>
                    )
                  ) : (
                    item.children
                  )}
                </TableData>
              </TableBody>
            ))}
          </Tr>
        </Content>
      )}
      <TextDefault>
        {`* 서비스 이용과정에서 서비스이용기록, 접속로그, IP주소, 쿠키(Cookie), 기기정보가 자동으로 수집될 수 있습니다. 자세한 내용은 페이지 하단의 '개인정보 처리방침'을 확인하세요.
http://mall.hanssem.com/customer/customerPrivacy.do`}
      </TextDefault>
    </Container>
  );
};

export default VisitPersonalInfoCollection;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 0px 40px 40px 40px;
`;

const TextDefault = styled.div`
  color: ${theme.colors.neutral_colors.gray[700]};
  white-space: pre-wrap;
  ${theme.typography.body2};
`;

const Content = styled.table`
  color: ${theme.colors.accent_colors.primary.default};
  margin-top: 20px;
  margin-bottom: 40px;
  border-top: 1px solid ${theme.colors.accent_colors.primary.default};
  ${theme.typography.subtitle5};
`;

const TableHeader = styled.th`
  width: 360px;
  height: 64px;
`;

const TableData = styled.div<{ type: 'head' | 'body'; height?: string }>`
  width: 100%;
  min-height: ${({ type }) => (type === 'body' ? '100px' : '100%')};
  border-bottom: 1px solid ${theme.colors.neutral_colors.gray[200]};
  height: ${({ height }) => height};
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  white-space: pre-wrap;
  color: ${theme.colors.accent_colors.primary.default};
  ${theme.typography.body2};
  p {
    color: ${theme.colors.accent_colors.primary.default};
    ${theme.typography.subtitle5};
    text-decoration: underline;
    text-underline-offset: 3px;
  }
`;

const Tr = styled.tr``;

const TableBody = styled.td`
  vertical-align: top !important;
  border-left: 1px solid ${theme.colors.neutral_colors.gray[200]};
  :first-child {
    border-left: none;
  }
`;
